import { Pipe, PipeTransform } from '@angular/core';
import { AppModule } from '../../app/app.module';
import { AppConfig } from '../../config/app.config';

@Pipe({
  name: 'quantityPipe',
})
export class QuantityPipe implements PipeTransform {
  /**
   * formats given number as quantity
   */
  transform(value: number, ...args) {
    var config = AppModule.injector.get(AppConfig);
    return value.toLocaleString(config.locale);
  }
}


// WEBPACK FOOTER //
// ./src/pipes/quantity/quantity.ts